<template>

        <tr v-if="block.type === 'subHeader'">
            <td class="amber lighten-1" colspan="11">{{ block.data.admin_block_name }}</td>
        </tr>
        <tr v-else>
            <td>{{ block.data.question }}</td>
            <td>{{ block.data.answer }} <v-btn v-if="mode === 'manager'" text small @click="editAnswer"><v-icon small>mdi-pencil</v-icon></v-btn>
                <v-dialog v-model="answerEdit.show" max-width="60%">
                    <v-card>
                        <v-card-title class="title">Редактирование ответа ТП</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-text-field v-if="!!answerEdit.show" outlined v-model="block.data.answer"></v-text-field>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-divider></v-divider>
                            <v-btn text color="info" @click="editAnswerCancel">Отмена</v-btn>
                            <v-btn text color="success" @click="editAnswerSave">Сохранить</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </td>
            <td class="text-center">
                <v-icon small v-if="block.data.file !== null && block.data.file !== ''" @click="viewFile('telegram', block.data.file)" color="success">mdi-file-find</v-icon>
                <v-icon v-if="mode === 'manager'" @click="selectFile('main')" small>mdi-dots-horizontal</v-icon>
            </td>
            <td class="text-center">
                {{ block.data.last_point }}
                <v-tooltip bottom v-if="block.data.last_point_comment">
                    <template v-slot:activator="{ on }">
                        <span v-on="on"><sup>*</sup></span>
                    </template>
                    <sup>{{ block.data.last_point_comment }}</sup>
                </v-tooltip>
            </td>
            <td class="text-center" v-if="!deletemode">
                <v-icon small :color="block.data.point <=0 ? `error` : `success`" @click="changePoint">{{ changePointIcon }}</v-icon>
            </td>
            <td class="text-center" v-if="!deletemode">
                {{ block.data.point_to_reports }}
            </td>
            <td class="text-center" v-if="!deletemode">
                <v-icon v-if="mode === 'manager'" :color="commentColor" class="hoverInfo" small @click="editComment">mdi-chat-processing</v-icon>
                <v-icon v-if="mode !== 'manager' && block.data.comment !== null && block.data.comment !== ''" :color="commentColor" class="hoverInfo" small @click="viewComment('manager')">mdi-chat-processing</v-icon>
            </td>
            <td v-if="!deletemode"><v-checkbox v-model="block.data.exclude" :disabled="mode !== 'manager'" @change="updateReport" dense hint="Исключить этот пункт из проверки"></v-checkbox></td>
            <td v-if="!!deletemode" colspan="4"><v-btn small text color="error" @click="deleteRowDouble">Удалить эту строку</v-btn></td>
            <td v-if="mode !== 'manager' || stage === 'C30:2'" class="text-center">
                <v-icon small v-if="block.data.sto_file !== null && block.data.sto_file !== ''" @click="viewFile('base64', block.data.sto_file)" color="success">mdi-file-find</v-icon>
                <v-icon v-if="mode !== 'manager' && mode !=='uk'" @click="selectFile('sto')" small>mdi-dots-horizontal</v-icon>
            </td>
            <td v-if="mode !== 'manager' || stage === 'C30:2'" class="text-center">
                <v-icon v-if="mode !== 'manager' && mode !=='uk'" :color="stoCommentColor" class="hoverInfo" small @click="editComment">mdi-chat-processing</v-icon>
                <v-icon v-if="(mode === 'manager' || mode === 'uk') && block.data.sto_comment !== null && block.data.sto_comment !== ''" :color="stoCommentColor" class="hoverInfo" small @click="viewComment('sto')">mdi-chat-processing</v-icon>
            </td>
        </tr>
</template>

<script>
  export default {
    name: 'ShopperShowTableBlock',
    props: {
      block: Object,
      mode: String,
      stage: String,
      ind: Number,
      deletemode: Boolean,
    },

    data: () => ({
        answerEdit: {
          show: false,
          data: null,
        }
    }),
    computed: {
        changePointIcon() {
          return this.block.data.point <= 0 ? 'mdi-minus-box' : 'mdi-plus-box'
        },
        commentColor() {
          return (this.block.data.comment !== null && this.block.data.comment !== '') ? `success` : ``
        },
          stoCommentColor() {
            return (this.block.data.sto_comment !== null && this.block.data.sto_comment !== '') ? `success` : ``
          },
    },
    methods: {
      deleteRowDouble: function () {
        this.$emit('deletedouble', this.block.data)
      },
      editAnswerSave: function () {
        this.answerEdit.show = false
        this.$emit('updatereport')
      },
      editAnswerCancel: function () {
        this.block.data.answer = '' + this.answerEdit.data + ''
        this.answerEdit.data = null
        this.answerEdit.show = false
      },
      editAnswer: function () {
        this.answerEdit.data = '' + this.block.data.answer + ''
        this.answerEdit.show = true
      },
      changePoint: function () {
        if(this.mode === 'manager') {
          let newpoint = this.block.data.point > 0 ? 0 : 1
          this.block.data.point = newpoint

          if(this.block.data.admin_block_id === 9) {
            this.block.data.point = newpoint * 2
            this.block.data.point_to_reports = newpoint * 2
          } else {
            this.block.data.point = newpoint
            if (this.block.data.point === 0) {
              if (this.block.data.last_point > 0) this.block.data.point_to_reports = newpoint
              if (this.block.data.last_point <= 0) this.block.data.point_to_reports = this.block.data.last_point - 1
            } else {
              this.block.data.point_to_reports = newpoint
            }
          }
          this.$emit('updatereport')
        }
      },
      selectFile: function(fileType = 'main') {
        let data
        data = {
            type: fileType,
            mode: this.mode,
            index: this.block.data.index,
            rows: 'points'
        }
        console.log('data', data, this.block.data)
        this.$emit('selectfile', data)
      },
      viewFile: function(mode = 'telegram', file = null) {
        if(file !== null) {
          this.$emit('viewfile', {
            mode,
            file
          })
        }
      },
      editComment: function() {
        let data
        data = {
          mode: this.mode,
          index: this.block.data.index,
          rows: 'points'
        }
        this.$emit('editcomment', data)
      },
      viewComment: function (type = null) {
        console.log('viecomment')
        if(type === 'manager') {
          this.$emit('viewcomment', this.block.data.comment)
        } else if (type === 'sto') {
          this.$emit('viewcomment', this.block.data.sto_comment)
        }
      },
      updateReport: function () {
        this.$emit('updatereport')
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
    .hoverInfo:hover {
        color: #2196F3;
    }
</style>